

















































































import Vue from "vue";
import {Component} from "vue-property-decorator";
import SectionHeader from "@/components/SectionHeader.vue";
import KeyValue from "@/components/KeyValue.vue";
import VueError from "@/components/VueError.vue";
import Success from "@/components/Success.vue";
import TimestampAgo from "@/components/TimestampAgo.vue";
import Loading from "@/components/Loading.vue";
import {NTag, NTagLocation} from "@/types/ntag";
import {curNtagClient, MoveEvent, NtagClient} from "@/services/NtagClient";
import LocationMovementsHistoryTable from "@/components/ntag/LocationMovementsHistoryTable.vue";
import {Location} from "@/types/core";
import {getBounds, getCenter} from 'geolib';
import {GeolibInputCoordinates} from "geolib/es/types";
import * as _ from 'lodash';

@Component({
  components: {
    SectionHeader,
    KeyValue,
    VueError,
    Success,
    TimestampAgo,
    Loading,
    LocationMovementsHistoryTable,
  },
})
export default class NtagSingleTag extends Vue {
  tag:NTag = {} as NTag;
  movements: MoveEvent[] = [];
  centralLocation: Location = {} as Location;
  httpBusyTag:boolean = false;
  httpBusyReadings:boolean = false;



  path:any = [];
  error:string = '';

  gmapOptions = {
    streetViewControl: false,
    mapTypeControl: false,
    zoom: 10,
  };

  gmapMarkerOptions = {
    opacity: 0.5,
  };

  defaultCentralLocation:Location = {
    type: "network",
    latitude: -33.869170,
    longitude: 151.206574,
  };

  // internal dependencies
  private ntagClient:NtagClient = curNtagClient;

  async mounted() {
    await this.refreshStatus();
  }

  async refreshStatus() {
    await this.getNtag();
    await this.loadNtagMovementsHistory();

    this.gmapOptions.zoom = this.zoomToBound();
  }

  async getNtag() {
    this.httpBusyTag = true;

    const reply = await this.ntagClient.getTag(this.$route.params.deviceId);

    this.httpBusyTag = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg) {
      return this.error = `Unable to retrieve tag ${this.$route.params.deviceId}: ${reply.errorMsg}`;
    }

    this.tag = reply.tag!;
  }

  async loadNtagMovementsHistory() {
    this.error = '';

    const reply = await this.ntagClient.getTagMovementsHistory(this.tag.id);

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve movements for tag ${this.$route.params.id}: ${reply.errorMsg}`;

    this.movements = reply.movements!.slice(0,100);
    this.centralLocation = this.getTagCenterLocation();

    this.path = _.map(_.filter(this.movements, (e) => e.location.bssGeoLocations.length>0), (item) => {
      return this.getLocationGeoCenter(item.location);
    });
  }

  get showTag():boolean {
    return !this.httpBusyTag && this.tag !== undefined;
  }

  get statusTopIconList():object[] {

    return [
      {name:'arrow-left', title:'back to tags list', event:'tags-list'},
      {name:'sync-alt', title:'reload status', event:'refresh-status'},
      {name:'external-link-alt', title:'device info', event:'device-page'}
    ];
  }

  getCoords() {
    const coordinates = _.map(this.movements, (item) => {
      const coord:GeolibInputCoordinates = this.getLocationGeoCenter(item.location);
      return coord;
    });

    return coordinates;
  }

  getTagCenterLocation():Location {
    const coordinates = this.getCoords();
    const center: false | {
      longitude: number;
      latitude: number;
    } = getCenter(coordinates);
    if ( center ) {
      const centerLocation: Location = {
        type: "network",
        latitude: center.latitude,
        longitude: center.longitude,
      }
      return centerLocation;
    }
    return this.defaultCentralLocation;
  }

  getLocationGeoCenter(location: NTagLocation) {
    return {
      lat: location.bssGeoLocations.length > 0 ? location.bssGeoLocations[0].lat : this.defaultCentralLocation.latitude,
      lng: location.bssGeoLocations.length > 0 ? location.bssGeoLocations[0].long : this.defaultCentralLocation.longitude,
    }
  }

  getTagBounds() {
    const coordinates = this.getCoords();
    const bounds = getBounds(coordinates);
    return bounds;
  }

  zoomToBound() {
    const bounds = this.getTagBounds()
    const GLOBE_WIDTH = 256; // a constant in Google's map projection
    const west = bounds.minLng;
    const east = bounds.maxLng;
    let angle = east - west;
    if (angle < 0) {
      angle += 360;
    }

    const pixelWidth = 60;

    return Math.min(Math.round(Math.log(pixelWidth * 360 / angle / GLOBE_WIDTH) / Math.LN2), 15);
  }

  navigateTo(dest:'tags-list'|'device-page') {
    switch(dest) {
      case 'tags-list': this.$router.push({ name: 'applications-ntag-tags'}); break;
      case 'device-page': this.$router.push({ name: 'device', params: { deviceId:this.tag.id }}); break;
    }
  }

  getLocationLabel(index: number, item: MoveEvent) {
    return `${item.location.name.charAt(0)}${item.location.name.charAt(1)}`;
  }

  get locationName() {
    return this.tag.location ? this.tag.location.name : '';
  }
}
